/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 出動次数
 */
export type IncidentSectionEnum =
  (typeof IncidentSectionEnum)[keyof typeof IncidentSectionEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IncidentSectionEnum = {
  FIRST: 'FIRST',
  SECOND: 'SECOND',
} as const;
